import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import madori from './modules/madori'
import editor from './modules/editor'
import item from './modules/item'
import palette from './modules/palette'
import dialog from './modules/dialog'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    member: null,
    initialized: false,
  },
  getters: {
    initialized(state) {
      return state.initialized
    },
    member_id(state) {
      return state.member ? state.member.id : null
    },
  },
  actions: {
    initialize({ commit, dispatch }, id) {
      return dispatch('item/fetchRemoteConfings')
        .then(() => dispatch('editor/fetchRemoteCalcVars'))
        .then(() => {
          dispatch('checkMemberLogin')
          return id ? dispatch('madori/fetchRemoteSavedata', id) : Promise.resolve()
        })
        .then(() => commit('initialized'))
    },
    checkMemberLogin({ commit }) {
      return axios.request({
        url: '/apis/getLoginInfo',
        method: 'get',
        headers: {
          'Accept-Language': 'ja,en-US;q=0.9,en;q=0.8',
        },
        responseType: 'json',
      })
      .then(response => {
        let { Member } = response.data
        if (Member) {
          commit('setMemberInfo', {
            id: parseInt(Member.id),
            nick_name: Member.nick_name,
          })
        }
      })
      .catch(function (error) {
        //console.log(error);
      })
    },
  },
  mutations: {
    initialized(state) {
      state.initialized = true
    },
    setMemberInfo(state, member) {
      state.member = member
    },
  },
  modules: {
    item,
    palette,
    madori,
    editor,
    dialog,
  },
  strict: debug,
  plugins: [],
})



// WEBPACK FOOTER //
// ./assets/js/store/index.js